import { axios } from '@/di-container/axios';
import {
  GetAgencyAgentsDetailGateway,
  GetApartRanksGateway,
  GetShopConsultantGateway,
  GetShopDetailGateway,
} from '@remodeling/shop';

export const shopDetailGateway = () => {
  return {
    getDetail: new GetShopDetailGateway(axios),
    getConsultantList: new GetShopConsultantGateway(axios),
    getApartRanksList: new GetApartRanksGateway(axios),
    getAgents: new GetAgencyAgentsDetailGateway(axios),
  };
};
